<template>
  <div v-if="visible" class="row mb-3 marichat-banner-row">
    <div class="col-md-12">
      <div class="card marichat-banner">
        <div class="card-body d-flex align-items-center flex-wrap">
          <!-- <div class="marichat-banner__icon mr-3">
            <i class="mdi mdi-rocket-launch mdi-36px"></i>
          </div> -->
          <div class="marichat-banner__text flex-grow-1 mr-3">
            <h5 class="mb-1">WAPPIN kini hadir dengan tampilan baru - MariChat ✨</h5>
            <p class="mb-0 text-muted">
              Lebih ringan dan lebih cepat diakses, dengan akun yang sama langsung masuk tanpa perlu login ulang.
            </p>
            <p class="text-muted mt-3">
              <strong>Mulai 1 September 2026,</strong> Seluruh pengguna akan otomatis beralih ke <strong>MariChat</strong> yg dapat diakses melalui <strong>app.mari.chat</strong>.
            </p>
            <p class="text-muted">
              Tampilan lama WAPPIN tidak lagi dapat diakses.
            </p>
            <p class="mb-0 mt-3 text-muted">
              Ada pertanyaan seputar transisi ini? Hubungi tim support kami.
            </p>
          </div>
          <div class="marichat-banner__actions d-flex align-items-center mt-2 mt-md-0">
            <button
              type="button"
              class="btn btn-primary text-white mr-2"
              :disabled="loading"
              @click="openMariChat">
              <i v-if="loading" class="mdi mdi-loading mdi-spin mr-1"></i>
              {{ loading ? 'Membuka…' : 'Coba MariChat' }}
            </button>
            <button
              type="button"
              class="btn btn-link text-muted p-1"
              :disabled="loading"
              title="Jangan tampilkan lagi"
              @click="dismiss">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authAPI from '../../api/auth';

// Dismiss di-scope ke SESI login sekarang (bukan permanen): kita simpan token yang
// sedang aktif saat user menutup banner. Login ulang = token baru = banner muncul lagi.
// Ini penting karena tujuannya full replace — user harus selalu aware tiap sesi.
// Pakai sessionStorage biar juga hilang saat tab/browser ditutup.
const DISMISS_KEY = 'marichat_banner_dismissed_token';

export default {
  name: 'MariChatBanner',
  data() {
    return {
      loading: false,
      dismissedToken: sessionStorage.getItem(DISMISS_KEY) || null,
    };
  },
  computed: {
    currentToken() {
      return this.$store.getters['auth/token'] || null;
    },
    visible() {
      // Tampil kecuali user sudah dismiss DI sesi (token) yang sama.
      return !this.dismissedToken || this.dismissedToken !== this.currentToken;
    },
  },
  methods: {
    openMariChat() {
      if (this.loading) return;
      this.loading = true;
      authAPI.ssoMariChat().then((res) => {
        const redirectUrl = res.data && res.data.redirect_url;
        if (redirectUrl) {
          // Redirect penuh ke MariChat; /cobrand di sana yang menukar token jadi sesi.
          window.location.href = redirectUrl;
        } else {
          this.loading = false;
          this.$store.dispatch('ui/alertError', 'Gagal membuka MariChat. Coba lagi.');
        }
      }).catch(() => {
        this.loading = false;
        this.$store.dispatch('ui/alertError', 'Gagal membuka MariChat. Coba lagi.');
      });
    },
    dismiss() {
      // Tandai dismiss hanya untuk token sesi ini; login berikutnya banner balik lagi.
      this.dismissedToken = this.currentToken;
      if (this.currentToken) {
        sessionStorage.setItem(DISMISS_KEY, this.currentToken);
      }
    },
  },
};
</script>

<style scoped>
.marichat-banner {
  border: none;
  background: linear-gradient(135deg, #128c7f 0%, #128c7f 100%);
  color: #fff;
}
.marichat-banner .card-body {
  gap: 0.5rem;
}
.marichat-banner__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  flex-shrink: 0;
}
.marichat-banner h5 {
  color: #fff;
}
.marichat-banner .text-muted {
  color: rgba(255, 255, 255, 0.85) !important;
}
.marichat-banner .btn-primary {
  background-color: #fff;
  border-color: #fff;
  color: #128c7f !important;
  font-weight: 600;
}
.marichat-banner .btn-primary:hover:not(:disabled) {
  background-color: #f2f0ff;
  border-color: #f2f0ff;
}
.marichat-banner .btn-link {
  color: rgba(255, 255, 255, 0.85) !important;
}
</style>
